module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Code/Spy-075451544b4c4e5c494e911f519ffb79d780129d172363ba04868cc0c10f55e8.svg";